import keyMirror from "keymirror";

const GetIssueIdOrKeyActionNames = keyMirror({
    GET_ISSUE_OR_KEY: null,
    GET_ISSUE_OR_KEY_SUCCESS: null,
    GET_ISSUE_OR_KEY_ERROR: null
});

export default GetIssueIdOrKeyActionNames;
